import React from "react";
import { ServiceConsumer } from "./ServcieProvder";
import { Api } from "../services/api";

export interface ServiceContainer {
  api: Api;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withServices = (Wrapped: React.ComponentType<any>) => {
  return (props: Record<string, unknown>) => (
    <ServiceConsumer>
      {(ctx: unknown) => {
        const { serviceContainer, setContainer } = ctx as {
          serviceContainer: ServiceContainer;
          setContainer: unknown;
        };
        return (
          <Wrapped
            {...props}
            serviceContainer={serviceContainer}
            setContainer={setContainer}
          />
        );
      }}
    </ServiceConsumer>
  );
};

export { withServices };
